module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text item"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "200px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否禁用",
      "prop": "disabled"
    }
  }, _vm._l((_vm.disabledArr), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.value
      },
      model: {
        value: (_vm.form.disabled),
        callback: function($$v) {
          _vm.$set(_vm.form, "disabled", $$v)
        },
        expression: "form.disabled"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "运营联系人信息",
      "type": "success",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "运营联系人姓名",
      "prop": "contact_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "运营联系人姓名"
    },
    model: {
      value: (_vm.form.contact_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "contact_name", $$v)
      },
      expression: "form.contact_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运营联系人电话",
      "prop": "contact_mobile"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "运营联系人电话"
    },
    model: {
      value: (_vm.form.contact_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "contact_mobile", $$v)
      },
      expression: "form.contact_mobile"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "入驻企业信息",
      "type": "success",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "（请填写您的品牌名称）"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营品类",
      "prop": "operating_type_id"
    }
  }, [(
    _vm.$route.query.id == undefined ||
    (_vm.$route.query.id == undefined && !_vm.form.operating_type_id)
  ) ? [_c('el-cascader', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "options": _vm.mainCategory
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.selectedMainCategory),
      callback: function($$v) {
        _vm.selectedMainCategory = $$v
      },
      expression: "selectedMainCategory"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("\n              请选择您的店铺主营品类，填写后不可更改\n            ")])] : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "content-padded view-flex view-flex-middle"
  }, [_c('el-breadcrumb', {
    staticClass: "inline",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l((_vm.categoryNames), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营品类(辅营)"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.mainCategory,
      "props": _vm.props
    },
    model: {
      value: (_vm.form.other_category_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "other_category_ids", $$v)
      },
      expression: "form.other_category_ids"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入驻商户类型",
      "prop": "merchant_type"
    }
  }, _vm._l((_vm.merchant_typeArr), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.value
      },
      model: {
        value: (_vm.form.merchant_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "merchant_type", $$v)
        },
        expression: "form.merchant_type"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商家类型",
      "prop": "type"
    }
  }, _vm._l((_vm.typeArr), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.value
      },
      model: {
        value: (_vm.form.type),
        callback: function($$v) {
          _vm.$set(_vm.form, "type", $$v)
        },
        expression: "form.type"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台服务费一",
      "prop": "platform_service_rate"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "费率（[提现手续费率]包含进费率里面） 比如 5% 就填 5"
    },
    model: {
      value: (_vm.form.platform_service_rate),
      callback: function($$v) {
        _vm.$set(_vm.form, "platform_service_rate", $$v)
      },
      expression: "form.platform_service_rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台服务费二",
      "prop": "platform_service_base_fee"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "[预留]复诊开方及处方流转等技术服务费(固定值)"
    },
    model: {
      value: (_vm.form.platform_service_base_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "platform_service_base_fee", $$v)
      },
      expression: "form.platform_service_base_fee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起送门槛设置",
      "prop": "threshold_setting"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "起送门槛设置/元"
    },
    model: {
      value: (_vm.form.threshold_setting),
      callback: function($$v) {
        _vm.$set(_vm.form, "threshold_setting", $$v)
      },
      expression: "form.threshold_setting"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商家承担配送费",
      "prop": "merchant_freight_fee"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "商家承担配送费/元"
    },
    model: {
      value: (_vm.form.merchant_freight_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_freight_fee", $$v)
      },
      expression: "form.merchant_freight_fee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.form.business_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_name", $$v)
      },
      expression: "form.business_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('business_license')
      }
    }
  }, [(_vm.form.business_license) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.business_license
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过500KB")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "请填写营业执照注册号"
    },
    model: {
      value: (_vm.form.business_license_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_license_no", $$v)
      },
      expression: "form.business_license_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执照名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "执照名称（请填写营业执照名称）"
    },
    model: {
      value: (_vm.form.business_license_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_license_name", $$v)
      },
      expression: "form.business_license_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司经营地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "请填写与您营业执照照片中地址保持一致"
    },
    model: {
      value: (_vm.form.business_address),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_address", $$v)
      },
      expression: "form.business_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业有效期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.timelimitDisabled,
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.selectTime()
      }
    },
    model: {
      value: (_vm.form.business_expire),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_expire", $$v)
      },
      expression: "form.business_expire"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": function($event) {
        return _vm.changeTime()
      }
    },
    model: {
      value: (_vm.timelimit),
      callback: function($$v) {
        _vm.timelimit = $$v
      },
      expression: "timelimit"
    }
  }, [_vm._v("长期有效")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "企业法定代表人基本信息(个人/企业法人)",
      "type": "success",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写营业执照中的法人"
    },
    model: {
      value: (_vm.form.operate_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "operate_name", $$v)
      },
      expression: "form.operate_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.form.operate_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "operate_mobile", $$v)
      },
      expression: "form.operate_mobile"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "证件号码（身份证）"
    },
    model: {
      value: (_vm.form.identity_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "identity_no", $$v)
      },
      expression: "form.identity_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件类型",
      "prop": "identity_type"
    }
  }, _vm._l((_vm.identity_typeArr), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.value
      },
      model: {
        value: (_vm.form.identity_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "identity_type", $$v)
        },
        expression: "form.identity_type"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("注意:身份证图片大小不超过500KB")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证正面"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('identity_front')
      }
    }
  }, [(_vm.form.identity_front) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.identity_front
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n                身份证正面|只能上传jpg/png文件，且不超过500KB\n              ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证反面"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('identity_backend')
      }
    }
  }, [(_vm.form.identity_backend) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.identity_backend
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n                身份证反面|只能上传jpg/png文件，且不超过500KB\n              ")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证有效日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.form.identity_begintime),
      callback: function($$v) {
        _vm.$set(_vm.form, "identity_begintime", $$v)
      },
      expression: "form.identity_begintime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.form.identity_endtime),
      callback: function($$v) {
        _vm.$set(_vm.form, "identity_endtime", $$v)
      },
      expression: "form.identity_endtime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "hidden": _vm.$route.query.id == undefined ? _vm.btn1 : true
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.next(1)
      }
    }
  }, [_vm._v("下一步,补充资质信息")])], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "hidden": _vm.$route.query.id == undefined ? _vm.next1 : false
    }
  }, [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "补充资质信息(可添加多个资质)",
      "type": "success",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.form.credentialArr), function(v, index) {
    return _c('el-card', {
      key: index,
      staticStyle: {
        "width": "40%",
        "display": "inline-block",
        "margin": "20px"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [_vm._v("补充资质信息:" + _vm._s(index + 1))]), _vm._v(" "), (index != 0) ? _c('el-button', {
      staticStyle: {
        "float": "right",
        "padding": "3px 0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeForm(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "资质证件类型"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (v.credential_type_id),
        callback: function($$v) {
          _vm.$set(v, "credential_type_id", $$v)
        },
        expression: "v.credential_type_id"
      }
    }, _vm._l((_vm.typeList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.title,
          "value": item.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "资质证件图片"
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('credential_url', index)
        }
      }
    }, [(v.credential_url) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": v.credential_url
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n                资质证件图片|只能上传jpg/png文件，且不超过500KB\n              ")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "有效期至"
      }
    }, [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "value-format": "yyyy-MM-DD",
        "placeholder": "选择日期"
      },
      model: {
        value: (v.credential_expire),
        callback: function($$v) {
          _vm.$set(v, "credential_expire", $$v)
        },
        expression: "v.credential_expire"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.addRule()
      }
    }
  }, [_vm._v("+补充资质")])], 1)], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "hidden": _vm.$route.query.id == undefined ? _vm.btn2 : true
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.next(2)
      }
    }
  }, [_vm._v("下一步,补充对公账户信息")])], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "hidden": _vm.$route.query.id == undefined ? _vm.next2 : false
    }
  }, [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "补充对公账户信息",
      "type": "success",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-row', [(_vm.form.merchant_type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "企业对公账户"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "企业对公账户"
    },
    model: {
      value: (_vm.form.accountArr.account_no),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "account_no", $$v)
      },
      expression: "form.accountArr.account_no"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "开户银行名称"
    },
    model: {
      value: (_vm.form.accountArr.parent_bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "parent_bank_name", $$v)
      },
      expression: "form.accountArr.parent_bank_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行支行名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "开户行支行名称"
    },
    model: {
      value: (_vm.form.accountArr.bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "bank_name", $$v)
      },
      expression: "form.accountArr.bank_name"
    }
  })], 1), _vm._v(" "), (_vm.form.merchant_type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "支付行号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "支付行号[企业支付行号12位数字"
    },
    model: {
      value: (_vm.form.accountArr.union_bank),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "union_bank", $$v)
      },
      expression: "form.accountArr.union_bank"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "银行卡号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "填写银行卡号"
    },
    model: {
      value: (_vm.form.accountArr.union_bank),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "union_bank", $$v)
      },
      expression: "form.accountArr.union_bank"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("银行卡号必须和身份证姓名一致")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行所在地"
    }
  }, [_c('el-cascader', {
    attrs: {
      "clearable": "",
      "options": _vm.regions
    },
    on: {
      "change": _vm.handleRegionChange
    },
    model: {
      value: (_vm.form.accountArr.regions_id),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "regions_id", $$v)
      },
      expression: "form.accountArr.regions_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行地区代码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "开户行地区代码（非必填）"
    },
    model: {
      value: (_vm.form.accountArr.bank_city_no),
      callback: function($$v) {
        _vm.$set(_vm.form.accountArr, "bank_city_no", $$v)
      },
      expression: "form.accountArr.bank_city_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "hidden": _vm.hidden
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goBack('form')
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bf408b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf408b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/merchant/merchants/edit.vue
// module id = 2691
// module chunks = 0